import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PilotAccreditation from '../components/PilotAccreditation';

const PilotCourses = () => (
  <div className="min-h-screen bg-gray-50">
    <Header />
    <PilotAccreditation />
    <Footer />
  </div>
);

export default PilotCourses;
